import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

export type AppRole = 'admin' | 'mediator' | 'seeker';

export const useUserRole = () => {
  const { user } = useAuth();

  return useQuery({
    queryKey: ['userRole', user?.id ?? null],
    queryFn: async () => {
      if (!user) return null;

      // Check each role
      const { data: isAdmin } = await supabase.rpc('has_role', {
        _user_id: user.id,
        _role: 'admin'
      });

      const { data: isMediator } = await supabase.rpc('has_role', {
        _user_id: user.id,
        _role: 'mediator'
      });

      const { data: isSeeker } = await supabase.rpc('has_role', {
        _user_id: user.id,
        _role: 'seeker'
      });

      if (isAdmin) return 'admin';
      if (isMediator) return 'mediator';
      if (isSeeker) return 'seeker';
      
      return null;
    },
    enabled: !!user,
    staleTime: 5 * 60 * 1000,
  });
};
